import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConstants, ErrorMessageFormField, STROBE_TYPE_LIST } from 'src/app/shared/app-constants';

@Component({
  selector: 'app-strobes-details-dialog',
  templateUrl: './strobes-details-dialog.component.html',
  styleUrls: ['./strobes-details-dialog.component.scss']
,
  standalone: false
})
export class StrobesDetailsDialogComponent implements OnInit {

  strobesInputForm: FormGroup = new FormGroup({});

  isAddButton: boolean = false;
  loading: boolean = false;
  isAddedData: boolean = false;
  deviceTypsData: any = STROBE_TYPE_LIST;
  headerName: string = '';
  editableStrobeData: any = {};
  hidePassword: boolean = true;
  errorMessageFormField: any = ErrorMessageFormField;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StrobesDetailsDialogComponent>,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    let site_Name = JSON.parse(sessionStorage.getItem("siteData"))?.potentialName
    this.strobesInputForm = this.formBuilder.group({
      strobeUniqueId: [''],
      name: ['', [Validators.required]],
      potentialId: [sessionStorage.getItem("potentialId"), [Validators.required]],
      strobeId: ['', [Validators.required]],
      ipAddress: ['', [Validators.required]],
      portNumber: [0, [Validators.required]],
      username: ['algo', [Validators.required]],
      password: ['', [Validators.required]],
      siteName: [site_Name, [Validators.required]],
      deviceName: ['', [Validators.required]],
      deviceType: ['Strobe', [Validators.required]],
    })
    const isAddOutputs = sessionStorage.getItem("isAddOutputs");
    if (isAddOutputs === 'true') {
      this.isAddButton = true;
      this.headerName = 'Add Algo Strobe';
    } else {
      this.isAddButton = false;
      this.headerName = `Edit Algo Strobe ${this.data?.deviceUniqueId}`;
      this.getDeviceByDeviceUniqueId(this.data && this.data?.deviceUniqueId);
    }
  }

  /** Check validation while adding the strobes all field filled or not */
  isAddValidation() {
    if (this.strobesInputForm.value.potentialId !== '' && this.strobesInputForm.value.name !== '' &&
      this.strobesInputForm.value.siteName !== '' && this.strobesInputForm.value.deviceName !== '' &&
      this.strobesInputForm.value.strobeId !== '' && this.strobesInputForm.value.ip !== '' &&
      this.strobesInputForm.value.portno !== '' && this.strobesInputForm.value.username !== '' && this.strobesInputForm.value.deviceType !== '' &&
      this.strobesInputForm.value.password !== '') {
      return true;
    } else {
      return false;
    }
  }

  /** This methods is used for adding Strobes */
  addStrobes() {
    const payloads: any = {
      potentialId: this.strobesInputForm.value.potentialId,
      name: this.strobesInputForm.value.name,
      ip: this.strobesInputForm.value.ipAddress,
      username: this.strobesInputForm.value.username,
      password: this.strobesInputForm.value.password,
      siteName: this.strobesInputForm.value.siteName,
      deviceName: this.strobesInputForm.value.deviceName,
      deviceType: this.strobesInputForm.value.deviceType,
      strobeId: this.strobesInputForm.value.strobeId,
      portno: parseInt(this.strobesInputForm.value.portNumber),
    }
    if (this.strobesInputForm.valid) {
      this.spinner.activate();
      this.loading = true;
      this.camService.addDevices(payloads, "STROBE_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is saved successfully.");
          this.dialogRef.close();
          this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.isAddedData = false;
          this.toastr.warning("Please try after some times");
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

  /** This methods is used for getting devices by unique ID */
  getDeviceByDeviceUniqueId(deviceUniqueId: string) {
    this.spinner.activate();
    this.loading = true;
    if (deviceUniqueId) {
      this.camService.getDeviceByDeviceUID(deviceUniqueId).subscribe((response: any) => {
        if (response && response.success) {
          this.editableStrobeData = response?.data;
          this.strobesInputForm = this.formBuilder.group({
            strobeUniqueId: response?.data?.device?.deviceUniqueId,
            name: response?.data?.device?.strobeData?.name,
            potentialId: response?.data?.device?.potentialId,
            strobeId: response?.data?.device?.strobeData?.strobeId,
            ipAddress: response?.data?.device?.strobeData?.ip,
            portNumber: response?.data?.device?.strobeData?.portno,
            username: response?.data?.device?.strobeData?.username,
            password: response?.data?.device?.strobeData?.password,
            siteName: response?.data?.device?.strobeData?.siteName,
            deviceName: response?.data?.device?.strobeData?.deviceName,
            deviceType: response?.data?.device?.strobeData?.deviceType,
          })

          this.spinner.deactivate();
          this.loading = false;

        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** This methods is used for Updating the Strobes*/
  updateStrobes() {
    const payloads: any = {
      deviceUniqueId: this.data?.deviceUniqueId,
      potentialId: this.data?.potentialId,
      ip: this.strobesInputForm.value.ipAddress,
      name: this.strobesInputForm.value.name,
      username: this.strobesInputForm.value.username,
      password: this.strobesInputForm.value.password,
      siteName: this.strobesInputForm.value.siteName,
      deviceName: this.strobesInputForm.value.deviceName,
      deviceType: this.strobesInputForm.value.deviceType,
      strobeId: this.strobesInputForm.value.strobeId,
      portno: parseInt(this.strobesInputForm.value.portNumber),
    }
    if (this.isAddValidation()) {
      this.spinner.activate();
      this.loading = true;
      this.camService.updateDevices(payloads, "STROBE_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is updated successfully.");
          this.dialogRef.close();
          // this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning("Please try after some times");
          // this.isAddedData = false;
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      // this.isAddedData = false;
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

}
